import React from 'react';
export function TrustStrip() {
  const logos = [{
    name: 'Oracle Health (Cerner)',
    src: 'https://cdn.magicpatterns.com/uploads/odekKBqKGFiab22TrwZBVf/Cerner-logo-white-horizontal.png',
    className: 'h-7 md:h-8'
  }, {
    name: 'athenahealth',
    src: 'https://cdn.magicpatterns.com/uploads/w4Huz3UJhBWwppeJuUfkk6/athenahealthlogo_RGB_primary_white2-1712234773299_copy.png',
    className: 'h-6 md:h-7'
  }, {
    name: 'UnitedHealthcare',
    src: 'https://cdn.magicpatterns.com/uploads/mswdjqnieTxKkZe95s3VDB/uhc-white.png',
    className: 'h-6 md:h-7'
  }, {
    name: 'Aetna',
    src: 'https://cdn.magicpatterns.com/uploads/rUzcy8rdAEK9du36PvmDFN/aetna_logo_white.png',
    className: 'h-6 md:h-7'
  }];
  return <section className="py-12 border-y border-hubble-border bg-hubble-ink relative z-10" data-id="element-205">
      <div className="max-w-7xl mx-auto px-6" data-id="element-206">
        <p className="text-center font-body text-sm text-hubble-paper/50 mb-8" data-id="element-207">
          Live across systems healthcare runs on, including:
        </p>

        <div className="flex flex-wrap justify-center items-center gap-10 md:gap-16" data-id="element-208">
          {logos.map(logo => <img key={logo.name} src={logo.src} alt={logo.name} className={`${logo.className} w-auto object-contain opacity-70 hover:opacity-100 transition-opacity duration-300`} data-id="element-209" />)}
        </div>
      </div>
    </section>;
}